import Lenis from "lenis";

let lenisInstance = null;

export function initLenis() {
  if (lenisInstance || typeof window === "undefined") return lenisInstance;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;

  lenisInstance = new Lenis({
    duration: 1.1,
    smoothWheel: true,
    touchMultiplier: 1.2,
  });

  function raf(time) {
    lenisInstance.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  return lenisInstance;
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset: -84, duration: 1.2 });
  } else {
    const y = el.getBoundingClientRect().top + window.pageYOffset - 84;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}
